import { render, staticRenderFns } from "./MoreLogin.vue?vue&type=template&id=ed2be57c&scoped=true"
import script from "./MoreLogin.vue?vue&type=script&lang=js"
export * from "./MoreLogin.vue?vue&type=script&lang=js"
import style0 from "./MoreLogin.vue?vue&type=style&index=0&id=ed2be57c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2be57c",
  null
  
)

export default component.exports